import { render, staticRenderFns } from "./createDepartment.vue?vue&type=template&id=db295670&scoped=true"
import script from "./createDepartment.vue?vue&type=script&lang=js"
export * from "./createDepartment.vue?vue&type=script&lang=js"
import style0 from "./createDepartment.vue?vue&type=style&index=0&id=db295670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db295670",
  null
  
)

export default component.exports